import { render, staticRenderFns } from "./PointLogs.vue?vue&type=template&id=710251d5&scoped=true&"
import script from "./PointLogs.vue?vue&type=script&lang=js&"
export * from "./PointLogs.vue?vue&type=script&lang=js&"
import style0 from "./PointLogs.vue?vue&type=style&index=0&id=710251d5&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "710251d5",
  null
  
)

export default component.exports